import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class AppLocalStorage {
    constructor() {}

    public storeToStorage = (key, value) => {
        // sessionStorage.setItem(key, btoa(unescape(encodeURIComponent(JSON.stringify(value)))))
        // sessionStorage.setItem(key, btoa(JSON.stringify(value)));
        try {
            const encodedValue = btoa(unescape(encodeURIComponent(JSON.stringify(value))));
            sessionStorage.setItem(key, encodedValue);
        } catch (error) {
            console.error("Error storing to storage:", error);
        }
    };

    public getFromStorage = (key) => {
        try {
            return JSON.parse(atob(sessionStorage.getItem(key)));
        } catch (error) {
            return null;
        }
    };

    public isStoredInSession = (key) => {
        return sessionStorage.getItem(key) ? true : false;
    };

    public removeFromStorage = (key) => {
        sessionStorage.removeItem(key);
    };

    public getAccessToken = () => {
        return sessionStorage.getItem("xs_access_token");
    };
    public setAccessToken = (value) => {
        sessionStorage.setItem("xs_access_token", value);
    };
}
